<div class="edit-profil-wrapper">
  <form [formGroup]="formGroup" class="edit-form" (ngSubmit)="onSubmit()">
    <div class="photo-section">
      <app-file-upload (fileEmitter)="receiveImage($event)" [imageUrl]="imageUrl"></app-file-upload>
    </div>

    <div class="form-fields">
      <div class="container-input">
        <input
          class="input-form"
          id="userName"
          type="text"
          formControlName="userName"
          placeholder="Pseudo"
        />
        @if (formGroup.get('userName')?.invalid && formGroup.get('userName')?.touched) {
        <span class="error">Le pseudo est requis (2-30 caractères)</span>
        }
      </div>

      <div class="container-input">
        <label class="label-form" for="city">Ville</label>
        <input
          class="input-form"
          id="city"
          type="text"
          formControlName="city"
          placeholder="Ville"
        />
      </div>

      <div class="container-input">
        <label class="label-form" for="description">À propos</label>
        <textarea
          class="input-form textarea"
          id="description"
          formControlName="description"
          placeholder="Décrivez-vous en quelques mots..."
          rows="4"
        ></textarea>
        <span class="char-count">{{ formGroup.get('description')?.value?.length || 0 }}/500</span>
      </div>
    </div>

    <div class="btn-actions">
      <button type="submit" class="btn-save" [disabled]="formGroup.invalid || isLoading">
        @if (isLoading) {
        <span>Enregistrement...</span>
        } @else {
        <span>Enregistrer</span>
        }
      </button>
    </div>
  </form>
</div>
